<template>
  <transition name="mu-modal-slide">
    <div class="mu-modal-wrapper" v-if="open" @click="close">
      <div @click.stop class="mu-modal" :style="{width: this.width}">
        <div class="mu-modal-body">
          <slot></slot>
        </div>
        <div @click.stop class="mu-action">
          <slot name="action"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },

    width: {
      type: [Number, String],
      default () {
        return '75%'
      }
    }
  },

  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less">
.mu-modal-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,0.4);
  z-index: 999;
  flex-direction: column;
}
.mu-modal {
  max-width: 768px;
  font-size: 16px;
}

.mu-modal-body {
  padding: 15px;
  background-color: #ffffff;
  border-radius: 8px;
}

.mu-modal-slide-enter-active,
.mu-modal-slide-leave-active{
  transition: opacity .45s cubic-bezier(0.23, 1, 0.32, 1);
  .mu-modal {
    backface-visibility: hidden;
    transition: transform .45s cubic-bezier(0.23, 1, 0.32, 1);
  }
}
.mu-modal-slide-enter,
.mu-modal-slide-leave-active {
    opacity: 0;
}

.mu-modal-slide-enter .mu-modal{
  transform: translate3d(0, -64px, 0);
}
.mu-modal-slide-leave-active .mu-modal{
  transform: translate3d(0, 64px, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue